import React from "react";

import CmsPreviewShell from "./CmsPreviewShell";
import mockData from "./mockData.json";

import type { CmsComponentProps, TourMock } from "./types";

const formatDateRange = (start: string, end: string) => {
  if (!start || !end) return "";
  const s = start.slice(5).replace("-", "/");
  const e = end.slice(5).replace("-", "/");
  return `${s} ~ ${e}`;
};

const remainingLabel = (capacity: number, booked: number) => {
  const left = Math.max(capacity - booked, 0);
  if (left === 0) return { text: "마감", urgent: true };
  if (left <= 2) return { text: `마감임박 ${left}석`, urgent: true };
  return { text: `잔여 ${left}석`, urgent: false };
};

const TourComponent: React.FC<CmsComponentProps> = ({ title, layout, items: userItems }) => {
  const items: TourMock[] =
    userItems && userItems.length > 0
      ? userItems
          .filter((i) => i.is_active !== false)
          .map((i, idx) => ({
            id: idx,
            title: i.title,
            img: i.img ?? "",
            region: i.region ?? "",
            startDate: i.start_date ?? "",
            endDate: i.end_date ?? "",
            capacity: i.capacity ?? 0,
            bookedCount: i.booked_count ?? 0,
          }))
      : (mockData.tour as TourMock[]);

  return (
    <CmsPreviewShell title={title}>
      <div className={`cms-tour cms-tour--${layout}`}>
        {items.map((item) => {
          const left = remainingLabel(item.capacity, item.bookedCount);
          return (
            <div key={item.id} className="cms-tour__item">
              <div className="cms-tour__image">
                {item.img ? <img src={item.img} alt={item.title} /> : <div className="cms-tour__placeholder">이미지 없음</div>}
                <span className={`cms-tour__remaining${left.urgent ? " cms-tour__remaining--urgent" : ""}`}>{left.text}</span>
              </div>
              <div className="cms-tour__body">
                <h5 className="cms-tour__title">{item.title}</h5>
                {item.region && <span className="cms-tour__region">📍 {item.region}</span>}
                {item.startDate && item.endDate && <span className="cms-tour__date">{formatDateRange(item.startDate, item.endDate)}</span>}
              </div>
            </div>
          );
        })}
      </div>
    </CmsPreviewShell>
  );
};

export default TourComponent;
